module.exports = __webpack_public_path__ + "static/img/return_good_example_2.4780436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_good_example_2.jpg
// module id = p2T5
// module chunks = 1